import { FC } from "react";
import { BigBlock } from "@/api/generated-api";
import S from "./index.module.scss";
import Image from "next/image";
import clsx from "clsx";

interface ITechnologyBig {
  data: BigBlock;
}

const TechnologyBig: FC<ITechnologyBig> = ({ data: { item } }) => {
  const { small_image, big_image, content, reverse } = item;

  return (
    <div className={clsx(S.block, { [S["block--reverse"]]: reverse })}>
      <Image className={S.smallImage} width={660} height={660} src={small_image} alt="smallImage" />
      <Image
        className={clsx(S.bigImage, { [S["bigImage--reverse"]]: reverse })}
        width={660}
        height={1200}
        src={big_image}
        alt="bigImage"
      />
      <div className={S.content} dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
};

export default TechnologyBig;
